import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { LoggedOutSearchTileWrapper } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/LoggedOutSearchTileWrapper";
import { Surface } from "@faire/web-api--source/faire/logging/data/Surface";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import { Grid } from "@faire/web/slate/Layout";

export const DiscoverProductTopLine: React.FC<{
  products: ILeanProductTile[];
  itemsPerRow: number;
  brandMap?: Partial<Record<string, ILeanProductTile.IBrand>>;
  requestId?: string;
}> = ({ products, itemsPerRow, brandMap, requestId }) => {
  const searchTerm = useSearchPageProductSearchString();
  const renderItem = (item: ILeanProductTile, index: number) => {
    const brand = brandMap && brandMap[item?.product?.brand_token ?? ""];
    return (
      <LoggedOutSearchTileWrapper
        requestId={requestId}
        brand={brand}
        productTile={item}
        index={index}
        productTileScreen={Surface.SEARCH_PRODUCT_RESULTS}
        context={`${ProductTileContainer.SEARCH_PRODUCT_RESULTS_GRID}|${searchTerm}`}
        productTileContainer={ProductTileContainer.SEARCH_PRODUCT_RESULTS_GRID}
        contextToken={searchTerm ?? ""}
        containerContext={
          ProductTileScreenContainer.SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS
        }
      />
    );
  };

  return (
    <Grid
      className="w-full px-1 md:px-0"
      columns={itemsPerRow}
      gap={{
        mobileAndAbove: "2x",
        tabletAndAbove: "3x",
      }}
    >
      {products.map(renderItem)}
    </Grid>
  );
};
